import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugin/element.js';
import { Tab, Tabs } from 'vant';

// 图片懒加载
import VueLazyload from 'vue-lazyload'
import Element from 'element-ui';
Vue.use(Element);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(VueLazyload, {
  preLoad: 1.3, //预加载高度
  // error: require('../static/img/error.jpg'), //错误展示图片
  loading: require('../src/assets/lazy.gif'), //加载等待图片
  attempt: 1 //尝试次数
})
import axios from 'axios'
import animated from '../node_modules/wowjs/css/libs/animate.css'
// import animated from './css/animate.css'

Vue.prototype.$bus = new Vue

//这里需要将样式用起来，
Vue.use(animated)
Vue.prototype.$EventBus = new Vue();

// console.log(store)

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  console.log(to, from, next);
})
Vue.config.productionTip = false

const getTxt = async () =>{
  return new Promise((resolve,reject) =>{
    const request = new XMLHttpRequest();
    request.open("GET",'static/code.txt',true);
    request.onreadystatechange = function () {
      if(request.readyState ===4){
        if(request.status==200 || request.status ==0){
          console.log(request.responseText)
          return resolve(request.responseText)
        }else{
          return reject('获取失败')
        }
      }
    };
    request.send(null);
  })
}

(async ()=>{
  const data = await getTxt()
  let formData = new FormData();
  formData.append('code',data);
  const newData = await axios.post('https://website.renhegroup.net/index.php/Home/Index/Api_Verification',formData,{
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  })
  if(newData.data.code===0){
    sessionStorage.setItem('codes',newData.data.result)
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})()

